import antdData from 'antd/lib/locale/ru_RU'
import localeData from 'react-intl/locale-data/ru'

const messages = {
  'topBar.issuesHistory': 'История заданий',
  'topBar.projectManagement': 'Управление проектом',
  'topBar.typeToSearch': 'Поиск...',
  'topBar.buyNow': 'Купить $24',
  'topBar.bitcoin': 'Биткоин',
  'topBar.profileMenu.hello': 'Привет',
  'topBar.profileMenu.billingPlan': 'Тарифный план',
  'topBar.profileMenu.role': 'Роль',
  'topBar.profileMenu.email': 'Емайл',
  'topBar.profileMenu.phone': 'Телефон',
  'topBar.profileMenu.editProfile': 'Редактировать профиль',
  'topBar.profileMenu.logout': 'Выйти',
}

export default {
  locale: 'ru-RU',
  antdData,
  localeData,
  messages,
}
